import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-volunteer-dialog",
  templateUrl: "./volunteer-calendar-legend.component.html",
})
export class VolunteerCalendarLegendDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<VolunteerCalendarLegendDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() { }
}
